$(document).on('Searchanise.ResultsUpdated', () => {
  hideTags();
  handleCollectionDescription();
});

$(document).on('click', '.snize-product-filters-list', function () {
    setTimeout(() => {
        hideTags();
    }, 50);
});




initDiscountHideCheck();

$(document).ready(function(){
  initFP();
  initTranslations();
  initCustomContactForm();
  hideDiscount();

  const collection = getUrlParams(location.search).collection;
  
  
  if (collection) {
    $('.mobile-menu').find('li').each((i, li) => {
      if ($(li).data('url') && $(li).data('url') === collection) {
        $(li).parents('ul').show();
        $(li).find('ul').first().show();
      }
    })
  } else {
    const page = (window.location+ '').split('/').slice(-1)[0];
    if (page) {
      $('.mobile-menu').find('li').each((i, li) => {
        if ($(li).data('url') && $(li).data('url') === page) {
          $(li).parents('ul').show();
          $(li).find('ul').first().show();
        }
      })
    }
  }

  if (window.innerWidth >= 1024) {
    checkStickySidebar();
    window.onscroll = function() {checkStickySidebar()};
  }
  var body = document.getElementsByTagName('body')[0];
  var video = document.getElementsByClassName('video')[0];
  if (video) {
    video.setAttribute('playsinline', true);
  }

  $("li.parent").find("a:first").click(function(e){
    e.preventDefault();
    $(this).next().trigger('click');
  });

  // contact form
  yose_contactForm();

  // drop zone

  document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
  const dropZoneElement = inputElement.closest(".drop-zone");
  if (!dropZoneElement) return; // <- skip if no valid parent

  dropZoneElement.addEventListener("click", (e) => {
    inputElement.click();
  });

  inputElement.addEventListener("change", (e) => {
    if (inputElement.files.length) {
      updateThumbnail(dropZoneElement, inputElement.files[0]);
    }
  });

  dropZoneElement.addEventListener("dragover", (e) => {
    e.preventDefault();
    dropZoneElement.classList.add("drop-zone--over");
  });

  ["dragleave", "dragend"].forEach((type) => {
    dropZoneElement.addEventListener(type, (e) => {
      dropZoneElement.classList.remove("drop-zone--over");
    });
  });

  dropZoneElement.addEventListener("drop", (e) => {
    e.preventDefault();

    if (e.dataTransfer.files.length) {
      inputElement.files = e.dataTransfer.files;
      updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
    }

    dropZoneElement.classList.remove("drop-zone--over");
  });
});




  
});

function initFP() {
  $(".heroSlider").owlCarousel({
        loop: true,
        dots: true,
        margin: 0,
        nav: true,
        center: false,
        autoplay: false,
        autoplayTimeout: 5000,
        navText: ['<span>←</span>', "<span>→</span>"],
        autoplayHoverPause: true,
        stagePadding: 0,
        autoHeight: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 1,
            },
        },
    });

  $(".slider-1").owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        navText: ["<span>←</span>", "<span>→</span>"],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 4,
            },
        },
    });

  $(".footerreivews").owlCarousel({
        loop: true,
        margin: 5,
        nav: false,
        center: false,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        stagePadding: 0,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 1,
            },
        },
    });
}


function initTranslations() {
  jQuery.extend(jQuery.validator.messages, {
    required: "Šis lauks ir obligāti jāaizpilda.",
    remote: "Lūdzu, labojiet šo lauku.",
    email: "Lūdzu, ievadiet derīgu e-pasta adresi.",
    url: "Lūdzu, ievadiet derīgu URL adresi.",
    date: "Lūdzu, ievadiet derīgu datumu.",
    dateISO: "Lūdzu, ievadiet derīgu datumu (ISO formātā).",
    number: "Lūdzu, ievadiet derīgu skaitli.",
    digits: "Lūdzu, ievadiet tikai ciparus.",
    creditcard: "Lūdzu, ievadiet derīgu kredītkartes numuru.",
    equalTo: "Lūdzu, ievadiet atkārtoti tādu pašu vērtību.",
    accept: "Lūdzu, ievadiet vērtību ar derīgu paplašinājumu.",
    maxlength: jQuery.validator.format("Lūdzu, ievadiet ne vairāk kā {0} rakstzīmes."),
    minlength: jQuery.validator.format("Lūdzu, ievadiet vismaz {0} rakstzīmes."),
    rangelength: jQuery.validator.format("Lūdzu, ievadiet vērtību no {0} līdz {1} rakstzīmēm garu."),
    range: jQuery.validator.format("Lūdzu, ievadiet vērtību no {0} līdz {1}."),
    max: jQuery.validator.format("Lūdzu, ievadiet vērtību, kas ir mazāka vai vienāda ar {0}."),
    min: jQuery.validator.format("Lūdzu, ievadiet vērtību, kas ir lielāka vai vienāda ar {0}.")
});
  
}


function yose_contactForm(){
    var $contactForm = $('.contact-form');

    if ( $contactForm.length > 0 ){
      $contactForm.each( function(){
        var el = $(this),
          elResult = el.find('.contact-form-result');

        el.find('form').validate({
          showErrors: function(errorMap, errorList) {
            this.defaultShowErrors();
          },
          submitHandler: function(form) {
            elResult.fadeOut( 500 );
            elResult.removeClass('alert alert-danger alert-success')

            $(form).ajaxSubmit({
              target: elResult,
              dataType: 'json',
              success: function( data ) {
                elResult.html( data.message ).fadeIn( 500 );
                elResult[0].scrollIntoView();
                
                if ( data.alert != 'error' ) {
                  elResult.addClass('alert alert-success')
                  
                  $(form).clearForm();
                  setTimeout(function(){
                    elResult.fadeOut( 500 );
                  }, 10000);

                  $(form).addClass('from-sent');
                  
                  document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
                    const dropZoneElement = inputElement.closest(".drop-zone");
                    dropZoneElement.querySelector(".drop-zone__prompt").style.display = 'flex';
                    dropZoneElement.querySelector(".drop-zone__thumb").remove();
                  });
                } else {
                  elResult.addClass('alert alert-danger')
                };
              }
            });
          }
        });

      });
    }
  }


/**
 * Updates the thumbnail on a drop zone element.
 *
 * @param {HTMLElement} dropZoneElement
 * @param {File} file
 */
function updateThumbnail(dropZoneElement, file) {
  let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");


  if (file === null) {
    thumbnailElement = document.createElement("div");
    thumbnailElement.classList.add("drop-zone__thumb");
    dropZoneElement.appendChild(thumbnailElement);
    return;
  }

  // First time - remove the prompt
  if (dropZoneElement.querySelector(".drop-zone__prompt")) {
    dropZoneElement.querySelector(".drop-zone__prompt").style.display = 'none';
  }

  // First time - there is no thumbnail element, so lets create it
  if (!thumbnailElement) {
    thumbnailElement = document.createElement("div");
    thumbnailElement.classList.add("drop-zone__thumb");
    dropZoneElement.appendChild(thumbnailElement);
  }

  thumbnailElement.dataset.label = file.name;

  // Show thumbnail for image files
  if (file.type.startsWith("image/")) {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
    };
  } else {
    thumbnailElement.style.backgroundImage = null;
  }
}


function checkStickySidebar() {
  const sidebar = $('.snize-filters-sidebar').first();
  const content = $('#snize_results').first();
  const footer = $('.box_footer').first();
  const footerHeigh = footer.outerHeight(true) + 48; // 39 is padding between sidebar and footer

  const distanceFromTop = window.pageYOffset
  const distanceFromBottom = document.documentElement.scrollHeight - (distanceFromTop + window.innerHeight);

  if (content.length > 0) {
    const distanceFromBottomOfContent = $(document).height() - (content.offset().top + content.outerHeight());

    if (sidebar.height() < content.height()) {
      if (distanceFromTop <= 92) {
        sidebar.attr('style', 'top: unset;bottom: unset');
      } else if (distanceFromBottom < distanceFromBottomOfContent + 25) { 
        sidebar.attr('style', `top: unset!important; bottom: 0!important;`);
      } else {
        sidebar.attr('style', `top: ${distanceFromTop - 38}px!important;bottom: unset`);
      }
    } 
  }
}
   
    



/**
 * Accepts either a URL or querystring and returns an object associating 
 * each querystring parameter to its value. 
 *
 * Returns an empty object if no querystring parameters found.
 */
function getUrlParams(urlOrQueryString) {
  if ((i = urlOrQueryString.indexOf('?')) >= 0) {
    const queryString = urlOrQueryString.substring(i+1);
    if (queryString) {
      return _mapUrlParams(queryString);
    } 
  }
  
  return {};
}

/**
 * Helper function for `getUrlParams()`
 * Builds the querystring parameter to value object map.
 *
 * @param queryString {string} - The full querystring, without the leading '?'.
 */
function _mapUrlParams(queryString) {
  return queryString    
    .split('&') 
    .map(function(keyValueString) { return keyValueString.split('=') })
    .reduce(function(urlParams, [key, value]) {
      if (Number.isInteger(parseInt(value)) && parseInt(value) == value) {
        urlParams[key] = parseInt(value);
      } else {
        urlParams[key] = decodeURI(value);
      }
      return urlParams;
    }, {});
}

function initCustomContactForm() {
  const contactRoot = document.querySelector('.contact-form');
  if (!contactRoot) return;

  const formEl = contactRoot.tagName === 'FORM' ? contactRoot : contactRoot.querySelector('form');
  if (!formEl) return;

  const resultBox = document.querySelector('.custom-contact-form-result');
  if (!resultBox) return;

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();

    resultBox.style.display = 'none';
    resultBox.classList.remove('success', 'error');

    const formData = new FormData(formEl);
    const actionUrl = formEl.action || formEl.getAttribute('action') || window.location.href;

    fetch(actionUrl, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json, text/html, */*' }
    })
    .then(async function (res) {
      const ct = res.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        return res.json();
      }
      const text = await res.text();
      try {
        return JSON.parse(text);
      } catch (parseErr) {
        // Native Shopify contact forms return a redirect + HTML page, not JSON.
        if (text.includes('form-success')) {
          return { alert: 'success', message: 'Paldies par ziņu!' };
        }
        if (text.includes('class="errors"') || text.includes("class='errors'")) {
          return { alert: 'error', message: 'Lūdzu, pārbaudiet formu un mēģiniet vēlreiz.' };
        }
        if (res.ok) {
          return { alert: 'success', message: 'Paldies par ziņu!' };
        }
        throw new Error('Unexpected response');
      }
    })
    .then(data => {
      resultBox.textContent = data.message || 'Atbilde nav pieejama.';
      resultBox.classList.add(data.alert === 'success' ? 'success' : 'error');
      resultBox.style.display = 'block';

      if (data.alert === 'success') {
        formEl.reset();
        const prompt = formEl.querySelector('.drop-zone__prompt');
        const thumb = formEl.querySelector('.drop-zone__thumb');
        if (prompt) prompt.style.display = 'flex';
        if (thumb) thumb.remove();
      }
    })
    .catch(err => {
      resultBox.textContent = 'Nezināma kļūda. Mēģiniet vēlreiz.';
      resultBox.classList.add('error');
      resultBox.style.display = 'block';
    });
  });
}
function hideTags() {
  const keywords = ['IMPORTED', 'ACTION REQUIRED', 'HANDLED'];

  $('#snize_filters_block_tags label').each(function () {
    const text = $(this).find('.needsclick').text().toUpperCase();
    if (keywords.some(keyword => text.includes(keyword))) {
      $(this).hide();
    }
  });
}


function hideDiscount() {
  if (localStorage.getItem('no_discount') === 'true') {
    document.documentElement.classList.add('no-discount');
  }
}

function initDiscountHideCheck() {
  // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Check for the specific rule parameter
    if (urlParams.get('rule') === 'Jqus2Qse1s') {
      // Set the no_discount flag in localStorage
      localStorage.setItem('no_discount', 'true');

      // Set a timestamp for expiry (current time + 1 hour)
      const expiryTime = Date.now() + (1 * 60 * 60 * 1000); // 1 hour in milliseconds
      localStorage.setItem('no_discount_expiry', expiryTime);
    }

    // Check expiry on every page load
    const expiry = localStorage.getItem('no_discount_expiry');
    if (expiry && Date.now() > expiry) {
      // Expired, clear the flag
      localStorage.removeItem('no_discount');
      localStorage.removeItem('no_discount_expiry');
    }
}

function handleCollectionDescription() {
  const $header = $('.collection-header');
  const $shortDesc = $('.collection-description-short'); // original Liquid
  const $fullDesc = $('#full-description');

  if (window.location.pathname.endsWith('/collections/compatible-parts')) {
    $header.hide();
    $shortDesc.hide();
    $fullDesc.hide();
  } else {
    $header.hide();

    // Always ensure short description is under Searchanise title
    const $snizeTitle = $('.snize-main-panel-collection-results-found');
    if ($snizeTitle.length && $('#snize-short-description').length === 0 && $shortDesc.length) {
      const cloned = $shortDesc.clone()
        .attr('id', 'snize-short-description')
        .addClass('snize-short-clone')
        .show();

      $snizeTitle.after(cloned);
      $shortDesc.hide();
    }

    // Always ensure full description is under results (new id)
    if ($('#snize_results').length && $('#collection-description').length === 0 && $fullDesc.length) {
      const clonedFull = $fullDesc.clone()
        .attr('id', 'collection-description')
        .addClass('snize-full-clone')
        .show();

      $('#snize_results').after(clonedFull);
      $fullDesc.hide();
    }

    // Update "Read more" button target if clone exists
    if ($('#collection-description').length) {
      $('.snize-short-clone .read-more-btn').attr('href', '#collection-description');
    }
  }
}

